import { IsEnable } from "../utils/enums";
import * as Components from "../components";
import * as Columns from "./Columns";
import dayjs from "dayjs";
import {PHONENO_VALIDATOR } from "../utils";

const IsEnableOptions = [
  {
    label: "Идэвхтэй",
    value: IsEnable.Идэвхтэй,
  },
  {
    label: "Идэвхгүй",
    value: IsEnable.Идэвхгүй,
  },
];
/* Хоолны бүртгэлийн формууд */
export const ProductAddForms = {
  url: "/product",
  method: "POST",
  isClear: true,
  isMessage: true,
  isRefresh: true,
  leftForms: {
    form: [
      {
        name: "code",
        label: "Код",
        type: "input",
        maxLength: 20,
        showCount: true,
        normalize: "number",
      },
      {
        name: "name",
        label: "Нэр",
        type: "input",
        required: true,
      },
      {
        name: "catid",
        label: "Ангилал",
        type: "select",
        options: "salecategory",
        fieldNames: { label: "name", value: "id" },
      },
      {
        name: "size",
        label: "Хэмжээ",
        type: "input",
        required: true,
        maxLength: 10,
      },
      {
        name: "cost",
        label: "Авах үнэ",
        type: "number",
        rules: ({ setFieldsValue }) => ({
          validator(_, value) {
            let regex = new RegExp("^[0-9]{1,10}$");
            if (!regex.test(value))
              return Promise.reject(
                new Error("Дээд тал нь 10 оронтой тоо оруулах боломжтой.")
              );
            else {
              /* setFieldsValue({ sprice: new Intl.NumberFormat().format(value) }); */
              return Promise.resolve();
            }
          },
        }),
        required: true,
      },
      {
        name: "price",
        label: "Зарах үнэ",
        type: "number",
        rules: () => ({
          validator(_, value) {
            let regex = new RegExp("^[0-9]{1,10}$");
            if (!regex.test(value))
              return Promise.reject(
                new Error("Дээд тал нь 10 оронтой тоо оруулах боломжтой.")
              );
            else {
              return Promise.resolve();
            }
          },
        }),
        required: true,
      },
      {
        name: "note",
        label: "Тайлбар",
        type: "textArea",
        maxLength: 1000,
        showCount: true,
        rows: 5,
      },
      {
        name: "isenable",
        required: true,
        label: "Төлөв",
        type: "select",
        options: IsEnableOptions,
      },
    ],
  },
};

export const OrderAddForms = {
  url: "/order",
  method: "POST",
  isClear: true,
  isMessage: true,
  isRefresh: true,
  leftForms: {
    form: [
      {
        name: "orderymd",
        label: "Огноо",
        required: true,
        defaultValue: dayjs(),
        type: "datepicker",
      },
      {
        name: "name",
        label: "Нэр",
        type: "input",
        required: true,
      },
      {
        name: "text",
        label: "Тайлбар",
        type: "textArea",
        maxLength: 1000,
        showCount: true,
        rows: 5,
      },
      {
        name: "isenable",
        required: true,
        label: "Төлөв",
        type: "select",
        options: IsEnableOptions,
      },
    ],
  },
  rightForms: {
    name: "details",
    url: "/order/detail",
    method: "POST",
    buttonText: "Шинэ бараа",
    Component: Components.FoodCardTable,
    columns: Columns.OrderDetailColumns,
  },
};

export const MoveAddForms = {
  url: "/movement",
  method: "POST",
  isClear: true,
  isMessage: true,
  isRefresh: true,
  leftForms: {
    form: [
      {
        name: "logymd",
        label: "Огноо",
        required: true,
        defaultValue: dayjs(),
        type: "datepicker",
      },
      {
        name: "storeid",
        label: "Энэ дэлгүүрээс",
        type: "select",
        options: "store",
        required: true,
        isChange: true,
        fieldNames: { label: "name", value: "id" },
      },
      {
        name: "fromid",
        label: "Энэ дэлгүүрлүү",
        type: "select",
        options: "store",
        required: true,
        fieldNames: { label: "name", value: "id" },
      },
      {
        name: "orderid",
        label: "Захиалга",
        type: "select",
        options: "orderdroplist",
        fieldNames: { label: "name", value: "id" },
        isChange: true,
      },
      {
        name: "name",
        label: "Нэр",
        type: "input",
        required: true,
      },
      {
        name: "qty",
        label: "Нэр төрлийн тоо",
        type: "input",
        disabled: true,
      },
      {
        name: "productqty",
        label: "Нийт барааны тоо",
        type: "input",
        disabled: true,
      },
      {
        name: "amt",
        label: "Нийт дүн",
        type: "number",
        disabled: true,
      },
      {
        name: "isenable",
        required: true,
        label: "Төлөв",
        type: "select",
        options: IsEnableOptions,
      },
    ],
  },
  rightForms: {
    name: "details",
    buttonText: "Шинэ бараа",
    Component: Components.FoodCardTable,
    columns: Columns.MoveDetailColumns,
  },
  initRequests: [
    {
      url: "/order/dropdown/$storeid",
      model: "orderdroplist",
      method: "POST",
    },
  ],
};

export const InvForm = {
  url: "/report/inventory/edit",
  method: "POST",
  isClear: true,
  isMessage: true,
  isRefresh: true,
  leftForms: {
    form: [
      {
        name: "code",
        label: "Код",
        type: "input",
        // required: true,
        disabled: true,
      },
      {
        name: "name",
        label: "Нэр",
        type: "input",
        required: true,
        disabled: true,
      },
      {
        name: "storeid",
        label: "Дэлгүүр",
        type: "select",
        options: "store",
        required: true,
        fieldNames: { label: "name", value: "id" },
        disabled: true,
      },
      {
        name: "productid",
        label: "Бараа",
        type: "select",
        options: "productlist",
        required: true,
        fieldNames: { label: "name", value: "id" },
        disabled: true,
      },
      {
        name: "qty",
        label: "Нэр төрлийн тоо",
        type: "minnumber",
        required: true,
      },
      {
        name: "note",
        label: "Тайлбар",
        type: "textArea",
        required: true,
        rows: 3,
      },
    ],
  },
};

export const BuyingAddForms = {
  url: "/product/buy",
  method: "POST",
  isClear: true,
  isMessage: true,
  isRefresh: true,
  leftForms: {
    form: [
      {
        name: "logymd",
        label: "Огноо",
        required: true,
        defaultValue: dayjs(),
        type: "datepicker",
      },
      {
        name: "name",
        label: "Нэр",
        type: "input",
        required: true,
      },
      {
        name: "supplierid",
        label: "Нийлүүлэгч",
        type: "select",
        options: "salesupplier",
        fieldNames: { label: "name", value: "id" },
      },
      {
        name: "storeid",
        label: "Дэлгүүр",
        type: "select",
        options: "store",
        defaultValue: 5,
        disabled: true,
        fieldNames: { label: "name", value: "id" },
      },
      {
        name: "qty",
        label: "Нэр төрлийн тоо",
        type: "input",
        disabled: true,
      },
      {
        name: "productqty",
        label: "Нийт барааны тоо",
        type: "input",
        disabled: true,
      },
      {
        name: "amt",
        label: "Нийт дүн",
        type: "number",
        disabled: true,
      },
    ],
  },
  rightForms: {
    name: "details",
    url: "/product/buy/details",
    method: "POST",
    buttonText: "Шинэ бараа",
    Component: Components.FoodCardTable,
    columns: Columns.BuyingDetailColumns,
  },
  initRequests: [
    {
      url: "/sale/supplier",
      model: "salesupplier",
      method: "POST",
    },
  ],
};

/* Хэрэглэгчийн эрх бүртгэлийн формууд */
export const UserPermForms = {
  url: "/user",
  method: "POST",
  isClear: true,
  isMessage: true,
  isRefresh: true,
  editBtn: true,
  leftForms: {
    form: [
      {
        name: "firstname",
        label: "Овог",
        type: "input",
        required: true,
      },
      {
        name: "lastname",
        label: "Нэр",
        type: "input",
        required: true,
      },
      {
        name: "phone",
        label: "Утасны дугаар",
        type: "input",
                      rules:PHONENO_VALIDATOR,
        required: true,
      },
      {
        name: "name",
        label: "Нэвтрэх нэр",
        type: "input",
        required: true,
      },
      {
        name: "storeid",
        label: "Салбар",
        type: "select",
        options: "store",
        fieldNames: { label: "name", value: "id" },
      },
      {
        name: "type",
        label: "Түвшин",
        type: "select",
        required: true,
        isChange: true,
        options: [
          {
            label: "Админ",
            value: 1,
          },
          {
            label: "Касс",
            value: 2,
          },
          {
            label: "Нягтлан",
            value: 3,
          },
        ],
      },
      {
        name: "pass",
        label: "Нууц үг",
        type: "password",
        // required: true,
      },
      {
        name: "isenable",
        required: true,
        label: "Төлөв",
        type: "select",
        options: IsEnableOptions,
      },
    ],
  },
};

export const CategoryAdd = {
  url: "/product/category",
  method: "POST",
  isClear: true,
  isMessage: true,
  isRefresh: true,
  leftForms: {
    form: [
      {
        name: "name",
        required: true,
        label: "Нэр",
        type: "input",
        maxLength: 50,
        showCount: true,
      },
      {
        name: "isenable",
        required: true,
        label: "Төлөв",
        type: "select",
        options: IsEnableOptions,
      },
    ],
  },
};

export const SupplierAdd = {
  url: "/product/supplier",
  method: "POST",
  isClear: true,
  isMessage: true,
  isRefresh: true,
  leftForms: {
    form: [
      {
        name: "name",
        required: true,
        label: "Нэр",
        type: "input",
        maxLength: 50,
        showCount: true,
      },
      {
        name: "isenable",
        required: true,
        label: "Төлөв",
        type: "select",
        options: IsEnableOptions,
      },
    ],
  },
};

export const StoreProductForm = {
  url: "/product/firstqty/{storeid}",
  method: "POST",
  isClear: true,
  isMessage: true,
  isRefresh: true,
  full: true,
  leftForms: {
    name: "details",
    url: "/material/buydetail",
    method: "GET",
    buttonText: "Шинэ бараа",
    Component: Components.StoreFood,
    columns: Columns.StoreFoodColumns,
  },
};
